import { render, staticRenderFns } from "./MailRecom.vue?vue&type=template&id=6ae73437"
import script from "./MailRecom.vue?vue&type=script&lang=js"
export * from "./MailRecom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports